import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { QuickMenuApi } from 'api';
import { IQuickMenu } from 'types';

function useGetAll() {
  return useAuthQuery(
    getQueryKeys([KEY]).lists(),
    () => QuickMenuApi.getAll(),
    {
      select: (data) => data.data as IQuickMenu[],
    },
  );
}

export default useGetAll;
